import $ from 'jquery';

const i18n = window.globalLegacyI18n.get('component/i18n/loader!legacy/global');

/**
   * show the quality score detail in the dialog next to it
   *
   * @param {Object} event - The backbone click event from where the quality score cell was clicked.
   * @param {Object} qualityScore - The qualityscore detailed object.
   * @param {String} qsContainerId - The container id to show the quality score detail info.
   * @returns {undefined}.
   */
export function showQualityScoreDetail(event, qualityScore, qsContainerId) {
  const {
    KeywordRelevance,
    LandingPageQuality,
    LandingPageRelevance,
    OverallQualityScore,
  } = qualityScore || {};

  $.gridPopup.clickEvent(event, () => {
    $.advertiser.controls.qualityscore.DisplayQsFlyout( // eslint-disable-line new-cap
      KeywordRelevance || 0,
      LandingPageQuality || 0,
      LandingPageRelevance || 0,
      OverallQualityScore || 0);
  },
  qsContainerId,
  `${i18n.getString('QualityScoreFlyOut_TotalScoreHeading')} ${OverallQualityScore} ${i18n.getString('QualityScoreFlyOut_TotalScore')}`);
}
